export const defaultProviderLogo =
  'https://truelayer-provider-assets.s3.amazonaws.com/global/icons/barclays.svg'

export const defaultProviderName = 'Barclays'
